const TABS = [
  { key: "org-setup", label: "Org Setup" },
  { key: "users", label: "Users" },
  { key: "solutions", label: "Solutions" },
  { key: "billing", label: "Billing" },
  { key: "checklist", label: "Checklist" },
];

export default function OrgWorkspaceTabs({ active, onChange }) {
  return (
    <div className="flex gap-2 overflow-x-auto border-b border-slate-200 pb-px dark:border-white/10" data-testid="org-workspace-tabs">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange(tab.key)}
          data-testid={`org-tab-${tab.key}`}
          className={`shrink-0 whitespace-nowrap border-b-2 px-4 py-3 text-sm font-bold transition-colors duration-200 ${
            active === tab.key ? "border-[#0052FF] text-[#0052FF] dark:text-blue-400" : "border-transparent text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
